export default [
  {
    path: '/app/hr-positions',
    name: 'HrPositions',
    component: () => import('@/views/Admin/HrPositions/Index.vue'),
    meta: {
      pageTitle: 'Açık Pozisyonlar',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_HR_POSITIONS_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/hr-positions/add',
    name: 'HrPositionsAdd',
    component: () => import('@/views/Admin/HrPositions/Add.vue'),
    meta: {
      pageTitle: 'Açık Pozisyonlar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/hr-positions',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_HR_POSITIONS_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/hr-positions/edit/:id',
    name: 'HrPositionsEdit',
    component: () => import('@/views/Admin/HrPositions/Edit.vue'),
    meta: {
      pageTitle: 'Açık Pozisyonlar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/hr-positions',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_HR_POSITIONS_EDIT',
      action: 'read',
    },
  },
]
